<h1 class="page-title mb-5">لماذا مصر</h1>
<div>
  <div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <h2>الاتفاقيات التجارية</h2>
        <p>
          توفر مصر ، التي تقع في موقع استراتيجي ، ميزة مثالية للوصول إلى الأسواق
          مع العديد من حوافز الاتفاقيات التجارية التي تستفيد منها مصر.
          <span>للمزيد اضغط هنا</span>
        </p>
        <h2>اقتصاد قوى وبيئة مواتية للاستثمار</h2>
        <p>
          قامت الحكومة المصرية منذ عام 2016 بتنفيذ برنامج طموح للإصلاح الاقتصادي
          تضمن إصلاحات مالية ونقدية تهدف إلى تحقيق معدلات نمو متسارعة ومستدامة،
          وتحقيق التنمية الشاملة لمصر حيث وضع هذا البرنامج حلولاً جذرية لمشكلات
          اقتصادية هيكلية كان يعاني منها الاقتصاد المصري لسنوات طويلة. ويأتي
          تنفيذ محاور هذا البرنامج في إطار رؤية مصر 2030 والتي تعكس الخطة
          الاستراتيجية طويلة المدى للدولة لتحقيق مبادئ وأهداف التنمية المستدامة
          في كل المجالات، وتوطينها بأجهزة الدولة المصرية المختلفة.
        </p>
        <img src="../../../assets/mainWhy/Untitled2.jpg" class="w-100" />
        <h2>برنامج الإصلاح الاقتصادي:​</h2>
        <p>
          تسعى الحكومة المصرية إلى تعزيز مرونة الاقتصاد المصري وتنوعه، وزيادة
          انتاجيته، وتحقيق النمو الشامل والمستدام، وفي هذا الإطار بدأت الدولة في
          نوفمبر 2016 بتنفيذ برنامج وطني شامل للإصلاح الاقتصادي والاجتماعي عملت
          من خلاله على تحقيق الاصلاح الاقتصادي كمرحلة أولى يتبعه برنامج
          للإصلاحات الهيكلية كمرحلة ثانية بما يضمن تفعيل واستدامة مكتسبات
          المرحلة الأولى من البرنامج الوطني للإصلاح الاقتصادي والاجتماعي
          واستدامتها.
        </p>
        <h2>أهداف برنامج الإصلاح الاقتصادي:</h2>
        <p>
          قامت الحكومة بتنفيذ المرحلة الأولى من برنامج الإصلاح الاقتصادي خلال
          الفترة من عام 2016 حتى إبريل 2021 وقد تضمنت هذه المرحلة إجراء إصلاحات
          مالية ونقدية تهدف إلى تحقيق معدلات نمو متسارعة ومستدامة، وتحقيق
          التنمية الشاملة لمصر حيث وضع هذا البرنامج حلولاً جذرية لمشكلات
          اقتصادية هيكلية كان يعاني منها الاقتصاد المصري لفترات طويلة​.
        </p>
        <img src="../../../assets/mainWhy/Untitled1.jpg" class="w-100" />
        <p>
          وقد أطلقت مصر المرحلة الثانية من برنامج الإصلاح الاقتصادي التي تختص
          بالإصلاحات الهيكلية في إبريل 2021، وتمتد على مدى ثلاث سنوات بعد أن
          أكملت المرحلة الأولى التي استهدفت معالجة اختلالات السياسات النقدية
          والمالية. ويستهدف البرنامج للمرة الأولى القطاع الحقيقي بإصلاحات هيكلية
          جذرية وهادفة، وسوف تسهم تلك الإصلاحات في زيادة مرونة الاقتصاد المصري،
          ورفع قدرته على امتصاص الصدمات الخارجية والداخلية، وتحويل مسار الاقتصاد
          المصري إلى اقتصاد إنتاجي يتمتع بمزايا تنافسية مما يدعم قدرته على تحقيق
          النمو المتوازن والمستدام. ​
        </p>
        <img src="../../../assets/mainWhy/reslts.jpg" class="w-100" />
        <h2>النتائج الإيجابية لبرنامج الإصلاح الاقتصادي:</h2>
        <p>
          اهم برنامج الإصلاح الاقتصادي الذي نفذته الحكومة المصرية في تحقيق نتائج
          إيجابية تمثلت في زيادة معدلات النمو الاقتصادي، وزيادة الاستثمارات
          المحلية والأجنبية، وزيادة نسب التشغيل، وتراجع معدلات البطالة والتضخم.
          كما ساهم تنفيذ محاور هذا البرنامج في تعزيز قدرة الاقتصاد المصري على
          مواجهة التداعيات السلبية لأزمة انتشار فيروس كورونا، وتمثلت أهم النتائج
          الإيجابية للبرنامج فيما يلي:
        </p>
        <img src="../../../assets/mainWhy/eco1.jpg" class="w-100" />
        <h2>مناخ الاستثمار في مصر:</h2>
        <p>
          شهد مناخ الاستثمار في مصر وخاصة في السنوات القليلة الماضية العديد من
          الإصلاحات التشريعية والمؤسسية بهدف تيسير وتبسيط الإجراءات على
          المستثمرين، مما ساهم في تحقيق نتائج إيجابية في مجال تأسيس الشركات من
          حيث الوقت والتكلفة وعدد الإجراءات اللازمة لبدء النشاط. ونتيجة هذه
          الإصلاحات نجحت مصر في تحقيق قفزة نوعية بمؤشر تأسيس الشركات في تقرير
          ممارسة أنشطة الأعمال لعام 2020 لتحتل المركز 90 بدلاً من المركز 109 في
          تقرير عام 2019.
        </p>
        <img src="../../../assets/mainWhy/2007ar.jpg" class="w-100" />
      </div>
      <div class="col-md-3">
        <app-fix-left-section></app-fix-left-section>
      </div>
    </div>
  </div>
</div>